export interface TokenNameId {
  clientId: string;
  tokenName: string;
}

export const API_GATEWAY_TOKEN_CLIENT = 'zvoove.api-gateway.token-def';
export const PDL_API_TOKEN_CLIENT = 'zvoove.pdl.api';

export const TOKEN_API_CLIENTS: TokenNameId[] = [
  { clientId: API_GATEWAY_TOKEN_CLIENT, tokenName: $localize`:@@token.partner:Partner Token` },
  { clientId: PDL_API_TOKEN_CLIENT, tokenName: $localize`:@@token.pdl:PDL Token` },
];
